export function calcularDuracao(horaInicial, horaFinal) {
  if (!horaInicial || !horaFinal || horaInicial === ":" || horaFinal === ":") {
    return null;
  }

  const [horaI, minutoI] = horaInicial.split(":").map(Number);
  const [horaF, minutoF] = horaFinal.split(":").map(Number);

  let inicial = new Date(0, 0, 0, horaI, minutoI);
  let final = new Date(0, 0, 0, horaF, minutoF);

  // 👉 Corrige se a hora final for no dia seguinte
  if (final <= inicial) {
    final.setDate(final.getDate() + 1);
  }

  const diff = final - inicial;
  const minutosTotais = Math.floor(diff / (1000 * 60));

  if (minutosTotais === 0) {
    return "00:00";
  }

  const horas = Math.floor(minutosTotais / 60);
  const minutos = minutosTotais % 60;
  return `${horas.toString().padStart(2, "0")}:${minutos
    .toString()
    .padStart(2, "0")}`;
}

export function calcularDiferencaRefeicao(eventos) {
  // Filtra os eventos com descricao_evento === "REFEICAO"
  const refeicoes = eventos.filter(
    (evento) => evento.descricao_evento === "REFEICAO"
  );

  if (refeicoes.length === 0) {
    return "00:00";
  }

  let totalMinutos = 0;

  refeicoes.forEach((refeicao) => {
    const [horasInicio, minutosInicio] = refeicao.hora_inicial
      .split(":")
      .map(Number);
    const [horasFim, minutosFim] = refeicao.hora_final.split(":").map(Number);

    const dateInicio = new Date();
    dateInicio.setHours(horasInicio, minutosInicio, 0, 0);

    const dateFim = new Date();
    dateFim.setHours(horasFim, minutosFim, 0, 0);

    // Calcula a diferença em minutos e soma ao total
    const diferencaMs = dateFim - dateInicio;
    totalMinutos += Math.floor(diferencaMs / (1000 * 60));
  });

  // Converte o total de minutos para horas e minutos
  const horas = Math.floor(totalMinutos / 60);
  const minutos = totalMinutos % 60;

  // Formata no estilo HH:MM
  const horasFormatadas = String(horas).padStart(2, "0");
  const minutosFormatados = String(minutos).padStart(2, "0");

  return `${horasFormatadas}:${minutosFormatados}`;
}

export function calcularDiferencaDescanso(eventos) {
  // Filtra os eventos com descricao_evento === "REFEICAO"
  const refeicoes = eventos.filter(
    (evento) => evento.descricao_evento === "INTERVALO"
  );

  if (refeicoes.length === 0) {
    return "00:00";
  }

  let totalMinutos = 0;

  refeicoes.forEach((refeicao) => {
    const [horasInicio, minutosInicio] = refeicao.hora_inicial
      .split(":")
      .map(Number);
    const [horasFim, minutosFim] = refeicao.hora_final.split(":").map(Number);

    const dateInicio = new Date();
    dateInicio.setHours(horasInicio, minutosInicio, 0, 0);

    const dateFim = new Date();
    dateFim.setHours(horasFim, minutosFim, 0, 0);

    // Calcula a diferença em minutos e soma ao total
    const diferencaMs = dateFim - dateInicio;
    totalMinutos += Math.floor(diferencaMs / (1000 * 60));
  });

  // Converte o total de minutos para horas e minutos
  const horas = Math.floor(totalMinutos / 60);
  const minutos = totalMinutos % 60;

  // Formata no estilo HH:MM
  const horasFormatadas = String(horas).padStart(2, "0");
  const minutosFormatados = String(minutos).padStart(2, "0");

  return `${horasFormatadas}:${minutosFormatados}`;
}

export function calcularHE50(jornada, refeicao, descanso, hNormal, adNoturno) {
  const jornadaMinutos = converterParaMinutos(jornada);
  const refeicaoMinutos = converterParaMinutos(refeicao);
  const descansoMinutos = converterParaMinutos(descanso);
  const hNormalMinutos = converterParaMinutos(hNormal);
  const adNoturnoMinutos = converterParaMinutos(adNoturno);

  const he50Minutos =
    jornadaMinutos -
    refeicaoMinutos -
    descansoMinutos -
    adNoturnoMinutos -
    hNormalMinutos;

  return converterParaHorasMinutos(he50Minutos);
}

function converterParaHorasMinutos(minutos) {
  const isNegativo = minutos < 0; // Verifica se o valor é negativo
  minutos = Math.abs(minutos); // Trabalha com o valor absoluto

  const horas = Math.floor(minutos / 60); // Calcula as horas
  const mins = minutos % 60; // Calcula os minutos

  // Formata o resultado com dois dígitos para horas e minutos
  const horasFormatadas = String(horas).padStart(2, "0");
  const minutosFormatados = String(mins).padStart(2, "0");

  // Adiciona o sinal negativo se necessário
  return isNegativo
    ? `-${horasFormatadas}:${minutosFormatados}`
    : `${horasFormatadas}:${minutosFormatados}`;
}

// Função para converter horas no formato HH:mm para minutos
export function converterParaMinutos(horas) {
  if (!horas) return 0; // Se não houver valor, retorna 0

  // Verifica se é um valor negativo
  const isNegativo = horas.startsWith("-");
  const horasLimpo = horas.replace("-", "");
  const [h, m] = horasLimpo.split(":").map(Number); // Divide horas e minutos
  const total = h * 60 + m; // Converte para minutos

  return isNegativo ? -total : total;
}

// Função para converter o formato de data AAAA-MM-DD para DD-MM-AAAA
export const formatDate = (dateString) => {
  const [year, month, day] = dateString.split("-");
  return `${day}-${month}-${year}`;
};

// Função para calcular o adicional noturno
export const calcularAdicionalNoturno = (eventos) => {
  let totalAdNoturno = 0;

  const eventosIgnorados = ["intervalo", "refeicao"];

  const eventosFiltrados = eventos.filter(
    (evento) =>
      !eventosIgnorados.includes(evento.descricao_evento?.toLowerCase() || "")
  );

  // Se não há eventos válidos, retorna 00:00
  if (eventosFiltrados.length === 0) {
    return "00:00";
  }

  // Verifica se há jornada válida (não 00:00)
  const temJornadaValida = eventosFiltrados.some(
    (evento) =>
      evento.hora_final &&
      evento.hora_final !== "00:00" &&
      evento.hora_final !== ":"
  );

  if (!temJornadaValida) {
    return "00:00";
  }

  eventosFiltrados.forEach((evento, index) => {
    const horaInicio = evento.hora_inicial;
    const horaFim = evento.hora_final;

    // Pula eventos sem hora final válida
    if (!horaFim || horaFim === "00:00" || horaFim === ":") {
      return;
    }

    const adNoturnoInicio = "22:00";
    const adNoturnoFim = "04:59";

    const toMinutes = (hora) => {
      const [h, m] = hora.split(":").map(Number);
      return h * 60 + m;
    };

    const inicioEvento = toMinutes(horaInicio);
    const fimEvento = toMinutes(horaFim);

    const inicioAdNoturno1 = toMinutes(adNoturnoInicio); // 1320
    const fimAdNoturno1 = toMinutes("23:59"); // 1439
    const inicioAdNoturno2 = toMinutes("00:00"); // 0
    const fimAdNoturno2 = toMinutes(adNoturnoFim); // 299

    // 1️⃣ Intervalo 22:00 - 23:59
    if (inicioEvento < fimAdNoturno1 && fimEvento > inicioAdNoturno1) {
      const inicio = Math.max(inicioEvento, inicioAdNoturno1);
      const fim = Math.min(fimEvento, fimAdNoturno1);
      const duracao = Math.max(0, fim - inicio);
      totalAdNoturno += duracao;
    }

    // 2️⃣ Intervalo 00:00 - 04:59
    if (inicioEvento < fimAdNoturno2 && fimEvento > inicioAdNoturno2) {
      const inicio = Math.max(inicioEvento, inicioAdNoturno2);
      const fim = Math.min(fimEvento, fimAdNoturno2);
      const duracao = Math.max(0, fim - inicio);
      totalAdNoturno += duracao;
    }
  });

  const horas = Math.floor(totalAdNoturno / 60);
  const minutos = totalAdNoturno % 60;

  return `${horas.toString().padStart(2, "0")}:${minutos
    .toString()
    .padStart(2, "0")}`;
};

export function calcularHE100(
  jornada,
  refeicao,
  descanso,
  adNoturno,
  isDomingo,
  isFeriado
) {
  // Converter todos os valores para minutos
  const jornadaMinutos = converterParaMinutos(jornada);
  const refeicaoMinutos = converterParaMinutos(refeicao);
  const descansoMinutos = converterParaMinutos(descanso);
  const adNoturnoMinutos = converterParaMinutos(adNoturno);

  // Se for domingo e houver jornada, calcula HE 100% considerando toda a jornada
  if ((isDomingo || isFeriado) && jornadaMinutos > 0) {
    const he100Minutos =
      jornadaMinutos - refeicaoMinutos - descansoMinutos - adNoturnoMinutos;

    // console.log("📌 Cálculo HE 100% (Domingo)");
    // console.log(
    //   `🕒 Cálculo HE 100 Jornada Total: ${jornada} (${jornadaMinutos} min)`
    // );
    // console.log(
    //   `🍽️ Cálculo HE 100 Refeição: ${refeicao} (${refeicaoMinutos} min)`
    // );
    // console.log(
    //   `😴 Cálculo HE 100 Descanso: ${descanso} (${descansoMinutos} min)`
    // );
    // console.log(
    //   `🌙 Cálculo HE 100 Ad. Noturno: ${adNoturno} (${adNoturnoMinutos} min)`
    // );
    // console.log(
    //   `⚡ Cálculo HE 100 HE 100% Calculado: ${converterParaHorasMinutos(
    //     he100Minutos
    //   )}`
    // );

    return converterParaHorasMinutos(he100Minutos);
  }

  // Se não for domingo ou não houver jornada, retorna "00:00"
  return "00:00";
}
